__turbopack_context__.v({
  "container": "NKjb0W_container",
  "cta": "NKjb0W_cta",
  "description": "NKjb0W_description",
  "desktopChart": "NKjb0W_desktopChart",
  "input": "NKjb0W_input",
  "mobileChart": "NKjb0W_mobileChart",
  "selectSum": "NKjb0W_selectSum",
  "suggestedSums": "NKjb0W_suggestedSums",
});
